// extracted by mini-css-extract-plugin
module.exports = {"dotSeparator":"dotseparator_dotSeparator__6bg60"};